import { Grid, Typography } from '@material-ui/core';
import React from 'react';

const DataView = ({ label, value, isPhone: vertical }) => (
  <Grid container alignItems="center" spacing={vertical ? 0 : 1}>
    <Grid item xs={12} md={'auto'}>
      <Typography
        variant={vertical ? 'body2' : 'subtitle1'}
        color="textSecondary"
      >
        {label}:
      </Typography>
    </Grid>
    <Grid item xs={12} md={'auto'}>
      <Typography variant="subtitle1" gutterBottom={!!vertical}>
        {value}
      </Typography>
    </Grid>
  </Grid>
);

export default DataView;
